import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsViewBlueprintsRoute: InvariantJiraRoute = {
	name: 'polaris-settings-view-blueprints',
	path: '/jira/settings/products/jira-product-discovery/view-blueprints',
	exact: true,
};
